import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Uploads as UploadsIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { CONTENT_COLLECTION_INSTRUCTIONS } from "../constants";
export const ContentCollectionOnboardingCard = (param)=>{
    let { description, onUpload, title } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-auto flex w-full flex-col items-center justify-center gap-4 rounded-t-16 border-0 border-t border-grey-5 bg-grey-1 p-4 md:my-auto md:w-[480px] md:rounded-8 md:border",
        "data-testid": "CONTENT_COLLECTION_ONBOARDING_CARD",
        children: [
            (!!title || !!description) && /*#__PURE__*/ _jsxs("header", {
                className: "flex w-full flex-col items-center gap-4 border-b border-b-grey-5 py-4 text-center",
                children: [
                    title && /*#__PURE__*/ _jsx("h1", {
                        className: "text-24 font-semibold text-grey-11",
                        "data-testid": "CONTENT_COLLECTION_ONBOARDING_CARD_TITLE",
                        children: title
                    }),
                    description && /*#__PURE__*/ _jsx("p", {
                        className: "text-14 text-grey-10",
                        "data-testid": "CONTENT_COLLECTION_ONBOARDING_CARD_DESCRIPTION",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full flex-col gap-2 rounded border border-grey-5 bg-grey-3 p-3",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-14 font-semibold text-grey-11",
                        children: "How it works"
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        children: CONTENT_COLLECTION_INSTRUCTIONS.map((instruction, index)=>/*#__PURE__*/ _jsxs("li", {
                                className: "flex flex-col gap-1 border-b border-b-grey-5 py-3 last:border-b-0 last:pb-0",
                                children: [
                                    /*#__PURE__*/ _jsxs("h3", {
                                        className: "flex items-center gap-3 text-14 font-medium text-grey-11",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex size-6 items-center justify-center",
                                                children: instruction.icon
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                children: instruction.label
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "pl-9 text-12 text-grey-10",
                                        children: instruction.description
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                className: "w-full",
                "data-testid": "CONTENT_COLLECTION_ONBOARDING_CARD_UPLOAD_ITEMS_BUTTON",
                onClick: onUpload,
                prefix: /*#__PURE__*/ _jsx(UploadsIcon, {
                    className: "size-5"
                }),
                size: "extra-large",
                children: "Upload items"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "hidden text-12 text-grey-9 md:block",
                children: "or drag and drop to upload"
            })
        ]
    });
};
